import { useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/store/use-ui-preferences-store";
import useAuthStore from "@/store/use-auth-store";
import { isPersonaPhoneComplete } from "../lib/completeness";
import { usePersonaSetup } from "../hooks/use-persona-setup";
import { QuestCard } from "../components/QuestCard";

const languageToCountry: Record<string, string> = {
  Turkish: "TR",
  English: "US",
  German: "DE",
  Arabic: "SA",
  Spanish: "ES",
  French: "FR",
  Italian: "IT",
};

export const PhoneQuest: React.FC = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const { saveFields, completeQuest, isSaving } = usePersonaSetup();
  const userPhone = useAuthStore((state) => state.user?.phoneNumber || "");
  const [phone, setPhone] = useState(userPhone);
  const ready = isPersonaPhoneComplete(phone);

  return (
    <QuestCard>
      <div className="mb-5 flex flex-col gap-1">
        <h2 className="text-xl font-bold text-text-primary dark:text-gray-100 sm:text-2xl">
          {t("personaSetup.quests.phone.title")}
        </h2>
        <p className="text-sm text-text-tertiary dark:text-gray-400">
          {t("personaSetup.quests.phone.description")}
        </p>
      </div>

      <div className="phone-input-wrapper flex h-12 items-center rounded-xl border border-border-primary bg-white px-3.5 transition-all focus-within:border-transparent focus-within:ring-2 focus-within:ring-text-brand dark:border-gray-600 dark:bg-gray-900 dark:focus-within:ring-indigo-400">
        <PhoneInput
          international
          defaultCountry={(languageToCountry[language] || "US") as "US"}
          value={phone || undefined}
          onChange={(value) => setPhone(value || "")}
          placeholder={t("settings.profile.phoneNumberPlaceholder")}
          className="phone-input w-full"
        />
      </div>

      <Button
        className="mt-6 w-full sm:w-auto"
        disabled={!ready || isSaving}
        onClick={async () => {
          if (await saveFields({ phoneNumber: phone })) {
            completeQuest("phone");
          }
        }}
      >
        {isSaving ? t("personaSetup.saving") : t("personaSetup.continue")}
      </Button>
    </QuestCard>
  );
};
